import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import TopBannerSection from './TopBannerSection'
import VerticalTemplateArea from './VerticalTemplateArea'
import DeviceSection from './DeviceSection'
import AISection from './AISection'
import HorizontalTemplateArea from './HorizontalTemplateArea'
import GuideSection from './GuideSection'
import VideoGuideArea from './VideoGuideArea'
import ReviewSection from './ReviewSection'
import TestimonialSection from './TestimonialSection'
import PartnerSection from './PartnerSection'
import PricingSection from './PricingSection'
import GenStudio from './GenStudio'

const NewLandingContainer = styled.div`
    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
`

const components = [
	TopBannerSection,
	VerticalTemplateArea,
	DeviceSection,
	AISection,
	HorizontalTemplateArea,
	GuideSection,
	VideoGuideArea,
	ReviewSection,
	TestimonialSection,
	PartnerSection,
	PricingSection,
	GenStudio
]

function NewLanding2024(props) {
    return (
        <NewLandingContainer>
            {
                components.map(Component => <Component {...props} />)
            }
        </NewLandingContainer>
    )
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,
})

export default connect(
    mapStateToProps,
    null
)(NewLanding2024)